// extracted by mini-css-extract-plugin
export var deg0 = "icons--deg0--4f667";
export var deg180 = "icons--deg180--108f6";
export var deg270 = "icons--deg270--e200f";
export var deg90 = "icons--deg90--5f7fa";
export var large = "icons--large--c1eb9";
export var medium = "icons--medium--b08a0";
export var responsive = "icons--responsive--cce4d";
export var small = "icons--small--850c9";